import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';

import DepartmentOwnerForm from '../components/DepartmentOwnerForm';
import { InputModel, DepartmentOwner } from '../models';
import { HttpClientError, RequestStatus } from 'http-client';
import {
    createDepartmentOwner, getList,
    reset,
    updateDepartmentOwner,
} from '../departmentOwner.reducer';
import {getList as getDepartmentList} from "../../department/department.reducer";
import {getList as getDistrictList} from "../../district/district.reducer";
import {getList as getTypeList} from "../../jobType/jobType.reducer";
import {savedStatusOption} from "../../../../helpers/alertLabel";

const DepartmentOwnerDetailPage = ({
    isEdit = false, ...props
}: DepartmentOwnerDetailPageProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);

    const isLoading = useAppSelector(
        (state: RootState) => state.departmentOwner.isLoading ?? false
    );
    const singleState = useAppSelector(
        (state: RootState) => state.departmentOwner.single ?? ({} as DepartmentOwner)
    );
    const error = useAppSelector(
        (state: RootState) => state.departmentOwner.error ?? ({} as HttpClientError)
    );

    const onSubmit = (formInput: InputModel) => {
        if (isEdit) {
            let _formInput = { ...formInput, id: singleState.id };
            dispatch(updateDepartmentOwner(_formInput));
        } else {
            dispatch(createDepartmentOwner(formInput));
        }
        dispatch(reset());
    };

    useEffect(() => {
        dispatch(getDistrictList({skip: 0, take: 500}));
        dispatch(getTypeList({skip: 0, take: 500}));
        dispatch(getDepartmentList({skip: 0, take: 500}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <DepartmentOwnerForm
                isLoading={isLoading}
                isEdit={isEdit}
                onSubmit={onSubmit}
            />
        </div>
    );
};

export interface DepartmentOwnerDetailPageProps {
    isEdit: boolean;
    toggleModal: () => void;
}

export default DepartmentOwnerDetailPage;
